<template>
  <nav class="resources-nav">
    <NuxtLink class="resources-nav__link" :to="localePath('/reports')">
      {{ $t('common.reports.title') }}
    </NuxtLink>
    <NuxtLink class="resources-nav__link" :to="localePath('/webinars')">
      {{ $t('common.webinars.title') }}
    </NuxtLink>
    <NuxtLink class="resources-nav__link" :to="localePath('/vlogs')">
      {{ $t('common.vlogs.title') }}
    </NuxtLink>
  </nav>
</template>

<script lang="ts" setup>
const localePath = useLocalePath()
</script>

<style lang="scss" scoped>
.resources-nav {
  display: flex;
  overflow-x: scroll;

  @media (min-width: $breakpoint-md) {
    overflow-x: hidden;
  }

  &__link {
    padding-left: 22px;
    padding-bottom: 18px;
    border-bottom: 2px solid var(--paper-300);
    width: 180px;
    color: var(--color-text);
    font-size: var(--font-size-paragraph-l);
    flex-shrink: 0;

    &:hover,
    &.router-link-active {
      color: var(--color-link);
      text-decoration: none;
      font-weight: var(--font-weight-paragraph-bold);
      border-bottom: 2px solid var(--color-link);
    }

    @media (min-width: $breakpoint-md) {
      width: 255px;
      flex-shrink: 1;

      &:first-child {
        padding-left: 0;
        width: 233px;
      }
    }
  }
}
</style>
